import { Routes } from '@angular/router';
import { adminRoutes } from '../../../admin/src/app/app.routes';

export const routes: Routes =
  adminRoutes
